var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"e-footer"},[_c('supporters',{staticClass:"e-footer__supporters"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }